var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sub-page',{attrs:{"title":_vm.title,"subtitle":_vm.subtitle,"description":_vm.description,"button-text":_vm.buttonText,"bg":_vm.bg,"right-bg":_vm.rightBg,"rightBg2":_vm.rightBg2,"partition":[6, 6],"rbgStyle":{
        position: 'relative',
        right: '-70px',
        bottom: '-100px'
    },"rbg2Style":{
        position: 'relative',
        zIndex: 1
    }}})
}
var staticRenderFns = []

export { render, staticRenderFns }